<template>
    <div class=""></div>
</template>

<script>
    //import { uniqueId } from 'lodash';

    export default {
        props: {
            disableNotify: false,
            disablePageLoading: false
        },
        data() {
            return {

            };
        },
        watch: {

        },
        mounted() {

        },
        methods: {
            onPageLoading( callback = ({ showLoading, message }) => {} ) {
                if( this.disablePageLoading ) {
                    return false;
                }

                this.$root.$on('pageLoading', ({ showLoading, message }) => callback( showLoading, message ));
            },
            triggerPageLoading( showLoading, message = '' ) {
                if( this.disablePageLoading ) {
                    return false;
                }

                this.$root.$emit('pageLoading', { showLoading, message });
            },

            onNotify( callback = () => {} ) {
                if( this.disableNotify ) {
                    return false;
                }

                this.$root.$on('notify', callback);
            },
            onNotifyBy( type = 'success', callback = () => {} ) {
                if( this.disableNotify ) {
                    return false;
                }

                this.onNotify(( payload ) => {
                   if( payload.type === type ) {
                       callback( payload );
                   }
                });
            },
            notifyBy( type = 'success', payload ) {
                if( this.disableNotify ) {
                    return false;
                }

                this.$root.$emit('notify', {
                    ...payload,
                    type
                });
            },

        }
    }
</script>
